module.exports = {
      id: "protichinta-logo-usage",
      viewBox: "0 0 190 57.9",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#protichinta-logo",
      toString: function () {
        return this.url;
      }
    }